import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewReply from './AddNewReply';

export default function ReplyFormButton({ id, LoadData }) {
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <AddNewReply
          id={id}
          toggleModal={() => {
            setIsUpdating(!isUpdating);
          }}
          formLabel="Edit Template"
          visible={isUpdating}
          LoadData={LoadData}
        />
      )}
    </div>
  );
}
